import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ApiService from './common/api.service'
import {
    CHECK_AUTH
} from '@/store/actions.type'
import VModal from 'vue-js-modal'
import VueSweetalert2 from 'vue-sweetalert2'
import {
    library
} from '@fortawesome/fontawesome-svg-core'
import {
    faBell,
    faClock,
    faComment,
    faComments,
    faEdit,
    faEnvelope,
    faEye,
    faFolder,
    faFolderOpen,
    faImage,
    faImages,
    faLaugh,
    faAngry,
    faQuestionCircle,
    faSave,
    faThumbsUp,
    faThumbsDown
} from '@fortawesome/free-regular-svg-icons'
import {
    faArrowLeft,
    faArrowUp,
    faAngleLeft,
    faAngleUp,
    faAngleDown,
    faAngleRight,
    faBars,
    faCloudUploadAlt,
    faExclamationTriangle,
    faExchangeAlt,
    faFilePdf,
    faHome,
    faList,
    faLink,
    faMinus,
    faMinusCircle,
    faNewspaper,
    faPollH,
    faPlus,
    faProjectDiagram,
    faSignOutAlt,
    faSignInAlt,
    faSlidersH,
    faStar,
    faTimes,
    faTrashAlt,
    faUpload,
    faUser,
    faUsers,
    faUserCog
} from '@fortawesome/free-solid-svg-icons'
import {
    FontAwesomeIcon
} from '@fortawesome/vue-fontawesome'
import Date from './plugins/date'
import Vuelidate from 'vuelidate'
import VuePageTransition from 'vue-page-transition'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import VueNumber from 'vue-number-animation'

library.add(faSlidersH, faUserCog, faImages, faStar, faNewspaper, faComments, faComment, faEye, faAngleUp, faImage, faAngleDown, faSignInAlt, faExchangeAlt, faLink, faMinus, faArrowUp, faUpload, faFolder, faFolderOpen, faPollH, faCloudUploadAlt, faClock, faExclamationTriangle, faUsers, faList, faAngleLeft, faAngleRight, faBell, faUser, faBars, faProjectDiagram, faPlus, faArrowLeft, faHome, faFilePdf, faEnvelope, faEdit, faMinusCircle, faTrashAlt, faTimes, faSave, faSignOutAlt, faQuestionCircle, faLaugh, faAngry, faThumbsUp, faThumbsDown)

Vue.component('v-select', vSelect)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VuePageTransition)
Vue.use(Vuelidate)
Vue.use(Date)
Vue.use(VModal)
Vue.use(VueSweetalert2)
Vue.use(VueNumber)

Vue.config.productionTip = false

ApiService.init()

// Ensure we checked auth before each page load.
router.beforeEach(
    (to, from, next) => {
        return Promise
            .all([store.dispatch(CHECK_AUTH)])
            .then(() => {
                next()
            })
    }
)

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
